// notifications
const header = $(".header")
const psyScaleHeader = $(".psy-scale__header")
function setPsyScaleTop() {
	let headerHeight = $(header).height();
	$(psyScaleHeader).css("top", headerHeight + "px");
};
setPsyScaleTop();

$(window).on("resize", function () {
	setPsyScaleTop();
});

// scroll service steps
class ScrollToggle {
	constructor(element) {
		this.container = element;
		this.toggles = this.container.querySelectorAll(".psy-scale__nav-btn");
		this.list = this.container.querySelector(".psy-scale__container");
		this.listItems = this.list.querySelectorAll(".psy-scale__item")
		this.scrollValue = 0;
	}
	init() {
		this.toggles.forEach(toggle => {
			toggle.addEventListener("mousedown", (e) => {
				this.move(e.target);
			})
			document.addEventListener("mouseup", (e) => {
				this.stop();
			})
		})
	}
	move(target) {
		if (target.classList.contains("psy-scale__nav-btn--right")) {
			this.interval = setInterval(() => {
				this.list.scrollLeft += 2;
			}, 1);
		} else {
			this.interval = setInterval(() => {
				this.list.ScrollLeft = this.scrollValue;
				this.list.scrollLeft -= 2;
			}, 1);
		}
	}
	stop() {
		if (this.list.scrollLeft > 0) {
			this.scrollValue = this.list.scrollLeft;
		}
		clearInterval(this.interval);
	}
}

document.querySelectorAll(".psy-scale").forEach(el => {
	const scrollToggle = new ScrollToggle(el);
	scrollToggle.init();
})

$(".psy-scale__header").on("scroll", function () {
	$(".psy-scale__header").not(this).scrollLeft($(".psy-scale__container").scrollLeft());
	$(".psy-scale__container").scrollLeft($(".psy-scale__header").scrollLeft());
});
$(".psy-scale__container").on("scroll", function () {
	$(".psy-scale__header").scrollLeft($(".psy-scale__container").scrollLeft());
	$(".psy-scale__container").not(this).scrollLeft($(".psy-scale__header").scrollLeft());
});

$(".scale-table__element-item--select .form-multi__top-input").on("focusin", function () {
	$(".scale-table__row").removeClass("active");
	$(this).closest(".scale-table__row").addClass("active");
});

$(".scale-table__element-item--select .form-multi__choice-input[type='radio']").on("change", function () {
	$(".scale-table__row").removeClass("active");
});

$(document).on("click", function (e) {
	if ($(".scale-table__row").hasClass("active")) {
		var callbackPopup = $(".scale-table__element-item--select");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".scale-table__row").removeClass("active");
		};
	}
});

$('.scale-table__block-add').click(function () {
	$(".popup-psy-scale-add").addClass("active");
	$("body").addClass("no-scroll");
})

$(".popup-psy-scale-add .popup__close, .popup-psy-scale-add .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});